module.exports = __webpack_public_path__ + "static/media/02en.76b671e2.jpg";